// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__jQZzB","modal":"styles_modal__zSygt","header":"styles_header__vsP4l","btnBack":"styles_btnBack__2Us8r","container":"styles_container__b7_P5"};